export enum SCREEN_QUERY {
    SMALL = '(max-width: 1023px)',
    MEDIUM = '(min-width: 1024px) and (max-width: 1399px)',
    LARGE = '(min-width: 1400px)',
}
